import styled from 'styled-components';
import { colors } from 'bench-style-constants';

const NOTE_ROW_GAP = 8;

export const NotesLayout = styled.div`
  padding: 8px;
`;

export const NotesGrid = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: 24px auto;
  grid-column-gap: 5px;
  grid-row-gap: ${NOTE_ROW_GAP}px;
`;

export const NotesLabelCell = styled.div`
  color: ${colors.dust};
  text-align: left;
`;

export const NotesListCell = styled.div`
  min-width: 0;
`;
